/*=============================
=         Form Process        =
=============================*/

var formMessage = document.getElementById('form-message');

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
    form.addEventListener('submit', formProcess);
});

function formProcess(e) {
    if('performance' in window === false)
        return true;

    e.preventDefault();

    var form = this,
        data = new FormData(form),
        button = this.querySelector('button[type="submit"]');

    button.classList.add('disabled');

    data.append('c_time', performance.now() >= 7000 ? 0 : 1);

    axios.post(form.action, data)
        .then(function(r) {
            Velocity(form, 'slideUp', {duration: 500, delay: 500});
            clearErrors(form);
            formMessage.classList.add('success');
            formMessage.innerHTML = r.data.message;

            if(typeof dataLayer !== 'undefined')
                dataLayer.push({'event': 'FormSubmission'});
        })
        .catch(function (e) {
            setTimeout(function() {
                button.classList.remove('disabled');
            }, 500);

            console.log(e.response.data.errors);

            formMessage.classList.add('error');
            formMessage.innerHTML = e.response.data.message;

            if(e.response.status===422) {
                clearErrors(form);
                setErrors(form, e.response.data.errors);
            }
        });
}

function clearErrors(form) {
    var errors = form.getElementsByClassName('error');

    for(var e=errors.length - 1; e>=0; e--)
        errors[e].classList.remove('error');

    Velocity(formMessage, 'scroll', {
        duration: 500,
        offset: -header.offsetHeight
    });
}

function setErrors(form, errors) {
    var firstField = false;

    if(Object.keys(errors).length) {
        var errorsList = document.createElement('ul');

        formMessage.appendChild(errorsList);
    }

    for(var key in errors) {
        var label = form.querySelector('label[for="'+key+'"]') || form.querySelector('fieldset[data-id="'+key+'"] legend');

        if(label)
            label.parentNode.classList.add('error');

        if(key == 'g-recaptcha-response')
            document.querySelector('.g-recaptcha').classList.add('error');

        var field = form.querySelector('*[name="'+key+'"]');

        if (field) {
            field.setAttribute('aria-describedby', key+'_error');

            if(!firstField) {
                field.focus();
                firstField = true;
            }

            var li = document.createElement('li');

            li.setAttribute('id', key+'_error');
            li.innerHTML = errors[key];
            errorsList.appendChild(li);
        }
    }
}

/*=============================
=      Conditional Display    =
=============================*/
function getParent(el) {
    return el ? el.parentNode.parentNode : false;
}

var conditionalFields = [].slice.call(document.querySelectorAll('#how_hear'));

conditionalFields.forEach(function(cond) {
    cond.addEventListener('change', function() {
        var isHowHear = this.id == 'how_hear',
            field = getParent(document.getElementById(isHowHear ? 'other' : (this.name == 'current_patient' ? 'dob' : 'first_request_msg')));

        if(this.value == (isHowHear ? 'Other' : 1))
            field.classList.remove('hidden');
        else
            field.classList.add('hidden');
    });
});
